import { ArrowRight, Check, ShieldCheck, Sparkles, Truck } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

const PricingSection = () => {
  const navigate = useNavigate();

  const features = [
    "Emballage protégé",
    "Livraison suivie en France et en Europe",
    "Prêt à offrir",
  ];

  return (
    <section id="pricing" className="section-shell relative py-24">
      <div className="container relative mx-auto px-6">
        <div className="overflow-hidden rounded-[2.4rem] bg-[linear-gradient(135deg,rgba(36,24,19,0.98),rgba(90,43,47,0.94))] px-8 py-10 text-white shadow-luxury md:px-12 md:py-14">
          <div className="grid gap-10 lg:grid-cols-[1.05fr_0.95fr]">
            <div>
              <h2 className="section-title max-w-2xl text-white">
                Recevez votre œuvre à partir de <span className="text-premium">29,99€</span>
              </h2>
              <p className="mt-5 max-w-lg text-base leading-7 text-white/74 md:text-lg">
                Plusieurs formats, livraison suivie.
              </p>

              <div className="mt-7 flex flex-wrap gap-3">
                <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm text-white/82">
                  <ShieldCheck className="h-4 w-4 text-accent" />
                  Qualité
                </div>
                <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm text-white/82">
                  <Truck className="h-4 w-4 text-accent" />
                  Livraison suivie
                </div>
                <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm text-white/82">
                  <Sparkles className="h-4 w-4 text-accent" />
                  Prêt à offrir
                </div>
              </div>
            </div>

            <div className="panel-strong rounded-[2rem] p-8 text-foreground shadow-card">
              <div className="mb-6 flex items-end justify-between gap-4">
                <div>
                  <div className="text-xs font-semibold uppercase tracking-[0.24em] text-foreground/42">Chaque commande</div>
                  <h3 className="mt-2 font-display text-4xl leading-none text-foreground">Finition Premium</h3>
                </div>
                <div className="rounded-full bg-foreground px-4 py-2 text-sm font-semibold text-white">
                  Dès 29,99€
                </div>
              </div>

              <div className="flex flex-col gap-4">
                {features.map((feature, index) => (
                  <div key={index} className="flex items-start">
                    <div className="mr-3 mt-1 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-primary/12">
                      <Check className="h-3.5 w-3.5 text-primary" />
                    </div>
                    <span className="leading-7 text-foreground/72">{feature}</span>
                  </div>
                ))}
              </div>

              <div className="mt-7 rounded-[1.4rem] bg-foreground/[0.04] p-5">
                <div className="text-sm font-semibold uppercase tracking-[0.22em] text-foreground/42">Formats</div>
                <p className="mt-2 text-sm leading-6 text-foreground/64">
                  Plusieurs dimensions disponibles.
                </p>
              </div>

              <Button
                variant="premium"
                size="lg"
                className="mt-8 h-14 w-full rounded-full"
                onClick={() => navigate("/create")}
              >
                Créer mon œuvre
                <ArrowRight className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
